import React from 'react';
import './src/styles/fontImports.css';
import { render } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './src/app/App';

render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.querySelector('#root'),
);

// =============================================
//   PWA 설치 프롬프트 전역 캡처
//   React lazy 컴포넌트보다 먼저 이벤트를 잡아두기 위해 entry point에서 처리
// =============================================
(window as any).__pwaInstallPrompt = null;

window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  (window as any).__pwaInstallPrompt = e;
  window.dispatchEvent(new Event('pwa-install-ready'));
});

window.addEventListener('appinstalled', () => {
  (window as any).__pwaInstallPrompt = null;
  window.dispatchEvent(new Event('pwa-app-installed'));
});

// =============================================
//   PWA Service Worker 등록
// =============================================
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('[SW] 등록 성공:', registration.scope);

        // 업데이트 감지
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'activated') {
                console.log('[SW] 새 버전 활성화됨');
              }
            });
          }
        });
      })
      .catch((error) => {
        console.error('[SW] 등록 실패:', error);
      });
  });
}
